import React, { useEffect, useRef, useState} from 'react';
import { exchangeDate, notify } from "../../helpers";
import { CalendarClock, Mail, MailCheck, MailPlus, MailWarning, MailX } from 'lucide-react';
import { Drawer } from 'vaul';
import { fetchFidelisPatientHistory } from '../../services/fidelisPatient';
import Spacing from '../Spacing';

const listItemStyle = {
  position: 'relative',
  marginBottom: '10px',
};

export default function FidelisPatientHistoryModal(props ) {
  const {
    account_id,
    location_id,
    emr_patient_id = null,
    activeModal = false,
    setActiveModal = () => {},
    previousScrollPosition = 0,
  } = props;

  const [loadHistoryData, setLoadHistoryData] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const dropdownRef = useRef(null);

  const loadData = async (accountId, locationId, emrPatientId) => {
    setLoadHistoryData(true);
    try {
      const response = await fetchFidelisPatientHistory(accountId, locationId, emrPatientId);
      if (response) {
        if (response?.detail) {
          notify('error', response?.detail);
        } else { 
          if(response?.data?.status === 'success'){
            setHistoryData(response?.data?.results);
          } else {
            notify("error", response?.data?.message);
          }
        }
      }
    } catch (error) {
      if (error?.response && error?.response?.data && error?.response?.data?.detail) {
        notify("error", error?.response?.data?.detail, 0.5);
      }
    } finally {
      setLoadHistoryData(false);
    }
  };

  useEffect(() => {
    loadData(account_id, location_id, emr_patient_id);
  }, [account_id, location_id, emr_patient_id]);

  const sortedHistoryData = Object.entries(historyData).sort(([dateA], [dateB]) => new Date(dateB) - new Date(dateA));

  const handleDrawerClose = () => {
    setActiveModal(false);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={activeModal} onOpenChange={handleDrawerClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4">
            <Drawer.Title className="sr-only">Patient Care Gap History</Drawer.Title>
            <Drawer.Description className="sr-only">View details of a parient</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_1 docpro_modal_sm" style={{ overflow: 'unset' }}>
              <div className="docpro_modal small custom-scroll">

                {loadHistoryData ? (
                  <div
                    style={{
                      height: "300px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    Loading...
                  </div>
                ) : (
                  <div className='docpro_bg_white'>
                    <h3 className="docpro_fs_18 docpro_mb_0">Message History</h3>
                    <Spacing lg="20" sm="20" />

                    <ul className='care_list_style fidelis_patient docpro_mb_0'>
                      {sortedHistoryData.length > 0 ?
                        sortedHistoryData.map(([date, messages], index) => (
                          <li key={index} style={listItemStyle}>
                            <CalendarClock width={21} height={21} color='#7b7b7b' style={{ position: 'absolute', top: 0, marginLeft: '-25px' }} />
                            <strong style={{ paddingLeft: '3px', color: '#373737e3' }}>
                              {exchangeDate(date)}:
                            </strong>
                            <div className='all_lists'>
                              {messages.map((message, messageIndex) => (
                                <div key={messageIndex} style={{ marginTop: '5px', display: 'flex' }}>
                                  {message?.status === 'delivered' ? 
                                    <span className='docpro_tip_checkbox'>
                                      <MailCheck color="green" width={18} height={18} style={{ marginRight: '8px' }} />
                                      <span className="docpro_tip">Delivered successfully</span>
                                    </span>
                                  : message?.status === 'failed' || message?.status === 'invalid_phone' ? 
                                    <span className='docpro_tip_checkbox'>
                                      <MailX color="red" width={18} height={18} style={{ marginRight: '8px' }} />
                                      <span className="docpro_tip">{message?.status === 'Failed' ? 'Failed to send' : 'Invalid recipient phone number'}</span>
                                    </span>
                                  : message?.status === 'queued' ? 
                                    <span className='docpro_tip_checkbox'>
                                      <MailPlus color="#47c1ff" width={18} height={18} style={{ marginRight: '8px' }} />
                                      <span className="docpro_tip">Message is in queue</span>
                                    </span>
                                  : message?.status === 'insufficient_credits' ? 
                                    <span className='docpro_tip_checkbox'>
                                      <MailWarning color="orange" width={18} height={18} style={{ marginRight: '8px' }} />
                                      <span className="docpro_tip">Insufficient credits</span>
                                    </span>
                                  : message?.status === 'scheduled' ? 
                                    <span className='docpro_tip_checkbox'>
                                      <MailWarning color="#3545ff" width={18} height={18} style={{ marginRight: '8px' }} />
                                      <span className="docpro_tip">Scheduled for later</span>
                                    </span>
                                  : 
                                    <span className='docpro_tip_checkbox'>
                                      <Mail color="#000000" width={18} height={18} style={{ marginRight: '8px' }} />
                                      <span className="docpro_tip">{message?.status || "Unknown status"}</span>
                                    </span>
                                  }

                                  <div>
                                    <p className='mb-1'>
                                      {message?.practice_location} 
                                      {message?.status === 'delivered' && 
                                        <small className='docpro_green_color'> - {message?.delivered_time}</small>
                                      }
                                    </p>
                                    <p style={{ marginBottom: '10px' }} dangerouslySetInnerHTML={{ __html: (message?.message_body || "").replace(/\n/g, "<br/>") }}></p>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </li>
                        ))
                      :
                        <div
                          style={{
                            height: "250px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          No history available
                        </div>
                      }
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}